class AjustarClassificacaoModal {
    static get $inject() {
        return ['UsuariosService', 'EfSocket']
    }

    constructor(UsuariosService, EfSocket) {
        this.UsuariosService = UsuariosService
        this.EfSocket = EfSocket
    }

    $onInit() {
        this.estoqueId = this.resolve.estoque.id
        this.channel = this.resolve.channel
        this.params = {
            ncm_corrigido: this.resolve.estoque.ncm,
            ex_tipi_corrigido: this.resolve.estoque.ex_tipi,
            cest_corrigido: this.resolve.estoque.cest
        }
    }

    submit(form) {
        if (form.$valid) {
            this.savePromise = this.save()
        }
    }

    async save() {
        const divergencia = await this._socket()
            .push(
                this.channel,
                "alterar_classificacao",
                { id: this.estoqueId, params: this.params }
            )

        this.close({ $value: divergencia })
    }

    _socket() {
        return this.EfSocket.socket(this.UsuariosService.token)
    }
}

angular.module('eficienciaFiscalModule')
    .component('ajustarClassificacaoModal', {
        controller: AjustarClassificacaoModal,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        template: `
        <form name="form" ng-submit="$ctrl.submit(form)" novalidate>
            <modal modal-title="Ajustar classificação do item" close="$ctrl.dissmiss.bind($ctrl)">
                <modal-body>
                    <div class="row">
                        <div class="form-group col-xs-12 col-sm-6">
                            <label>NCM</label>
                            <input type="text" name="ncm" class="form-control" ng-model="$ctrl.params.ncm_corrigido" max="8" min="8" />
                        </div>
                        <div class="form-group col-xs-12 col-sm-3">
                            <label>ExTIPI</label>
                            <input type="text" name="ex_tipi" class="form-control" ng-model="$ctrl.params.ex_tipi_corrigido" max="4" min="2" />
                        </div>
                        <div class="form-group col-xs-12 col-sm-3">
                            <label>CEST</label>
                            <input type="text" name="cest" class="form-control" ng-model="$ctrl.params.cest_corrigido" max="7" min="7" />
                        </div>
                    </div>
                </modal-body>
                <modal-footer>
                    <promise-tracker promise="$ctrl.savePromise" active="active">
                        <button class="btn btn-primary" type="submit" ng-hide="active">Salvar</button>
                        <button class="btn btn-primary" type="button" disabled ng-show="active">
                            <i class="fa fa-spin fa-circle-o-notch"></i>
                            Salvando...
                        </button>
                        <button class="btn btn-default" type="button" ng-click="$ctrl.dismiss()">Fechar</button>
                    </promise-tracker>
                </modal-footer>
            </modal>
        </form>
        `
    })
